import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';
import { Link } from 'react-router-dom';
import TreatmentIntroBanner from '../../../components/treatmentBanner/treatmentBanner';

const WeightLossInjectionsPage = () => {
	const prices = [{ label: 'Treatment', value: 'Price on Consult' }];

	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<TreatmentIntroBanner
								title="Weight-Loss Injections"
								description="Non-surgical injections that target and dissolve stubborn fat cells, naturally flushed via the lymphatic system—ideal for contouring the jawline, under-chin, neck, and other small areas."
								quote=" Precision contouring with minimal downtime. "
								backgroundImage="/assets/images/banners/treatment-xl-2.png"
							/>

							<div className="section mcb-section" id="image" style={{ paddingBottom: '70px' }}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-third column_image">
												<div className="image_frame image_item scale-with-grid aligncenter has_border hrmargin_b_30">
													<div className="image_wrapper">
														<div className="mask"></div>
														<img
															className="scale-with-grid"
															src="/assets/images/treatments/weight-loss-injections.jpg"
															alt="Fat Dissolving Injection"
															width="960"
															height="960"
														/>
													</div>
												</div>
											</div>

											<div className="column mcb-column two-third column_column">
												<div className="column_attr clearfix">
													<h4>How It Works</h4>
													<p>
														These injections use a sclerosant (like deoxycholic acid) to destroy fat cells in the treated area. The
														body then safely clears the broken-down cells through its lymphatic system.
													</p>

													<h4>What to Expect</h4>
													<ul>
														<li>Treatment takes approximately 15-30 minutes.</li>
														<li>Results begin to appear within 1-2 weeks, improving gradually over time.</li>
														<li>Minimal downtime—usually only mild swelling, redness, or bruising for 3-5 days.</li>
														<li>Permanent reduction of treated fat cells with a healthy lifestyle.</li>
													</ul>

													<h4>Benefits</h4>
													<ul>
														<li>Targeted removal of stubborn fat pockets resistant to diet and exercise.</li>
														<li>Non-surgical alternative to liposuction, with rapid recovery.</li>
														<li>Gradual, natural-looking contouring.</li>
													</ul>

													<h4>Possible Side Effects</h4>
													<ul>
														<li>
															Temporary swelling, redness, soreness, and sensitivity at the injection site (usually resolve within
															a few days)
														</li>
														<li>Rarely, redness, tightness or mild itching.</li>
													</ul>
												</div>
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>
															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	{prices.map(({ label, value }, idx) => (
																		<li key={idx} className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																			<div>
																				<strong>{label}</strong>
																			</div>
																			<div style={{ whiteSpace: 'pre-line' }}>{value}</div>
																		</li>
																	))}
																</ul>
																<hr className="bg-theme" />
															</div>
															<div className="plan-footer">
																<Link to="/book-now" className="button button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column one column_slider">
												<div className="column_attr clearfix hrmargin_b_60">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														Results
													</h2>
													<div className="content_slider">
														<ul className="content_slider_ul">
															<li className="content_slider_li_1">
																<img
																	width="100%"
																	height="auto"
																	src="/assets/images/treatments/weight-loss-injections-result.jpg"
																	alt="Weight Loss Injection result"
																	className="scale-with-grid wp-post-image"
																/>
															</li>
														</ul>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														After-Care
													</h2>
													<ul>
														<li>
															Avoid aspirin or ibuprofen for 1 week before and 2 days after treatment to minimise bruising and
															reduce the risk of inflammation.
														</li>
														<li>
															Avoid heat, such as saunas, hot showers or pools, for 3 days post-treatment to prevent irritation
															and allow proper healing.
														</li>
														<li>
															Light walking is OK; avoid vigorous exercise, intense cardio, or heavy lifting for approximately 10
															days to avoid swelling.
														</li>
														<li>
															Don't apply makeup or skincare for 12 hours; use clean applicators and avoid shared products for up
															to 5 days post-treatment.
														</li>
														<li>
															Wait 14 days before re-treating or combining with other procedures to give the skin sufficient time
															to recover naturally.
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default WeightLossInjectionsPage;
